import React, {Component} from 'react';
import {toastr} from 'react-redux-toastr';
import {connect} from 'react-redux';
import {withStyles} from 'material-ui/styles';
import styles from '../style/styles';
import StaffTranslationEdit from './StaffTranslationEdit';
import StaffTranslationView from './StaffTranslationView';
import {
    canEditOrViewTranslation
} from '../../../components/permissions/permissions';
import {
    fetchStaffMember,
    fetchStaffTranslation,
} from '../thunks';
import {
    fetchSites,
} from '../../sites/thunks';

class StaffEditViewTranslation extends Component {

    componentWillMount() {
        this.props.fetchSites();
        this.props.fetchStaffTranslation(
            this.props.match.params.staffId, 
            this.props.match.params.translationId
        );
        this.props.fetchStaffMember(this.props.match.params.staffId);
    }

    componentWillUnmount() {
        toastr.removeByType('error');
    }

    render() {

        const {
            staffTranslation,
            staffMember,
            sites,
            classes
        } = this.props;

        const EditTranslationPage = () => (
            <StaffTranslationEdit
                staffMember={staffMember}
                staffTranslation={staffTranslation}
                sites={sites}
                classes={classes}
                staffId={parseInt(this.props.match.params.staffId, 10)}
                staffTranslationId={parseInt(this.props.match.params.translationId, 10)}
            />
        )
        const ViewTranslationPage = () => (
            <StaffTranslationView
                staffMember={staffMember}
                staffTranslation={staffTranslation}
                sites={sites}
                classes={classes}
            />
        )

        let EditOrViewTranslationPage = canEditOrViewTranslation(EditTranslationPage, ViewTranslationPage);

        return (
            <div>
                <EditOrViewTranslationPage />
            </div>
        )
    }
}

const mapStateToProps = (state, props) => ({
    staffMember: state.staff.staffMember,
    staffTranslation: state.staff.staffTranslation,
    sites: state.sites.all,
});

export default connect(mapStateToProps, {
    fetchStaffMember,
    fetchSites,
    fetchStaffTranslation,
})(withStyles(styles)(StaffEditViewTranslation));



// WEBPACK FOOTER //
// ./src/containers/staff/translations/StaffEditViewTranslation.jsx